var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 54,
    viewBox: "0 0 38 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 53.3333C18.0444 53.3333 17.5111 53.1556 17.0667 52.8C16.6222 52.4445 16.2889 51.9778 16.0667 51.4C15.2222 48.9111 14.1556 46.5778 12.8667 44.4C11.6222 42.2222 9.86667 39.6667 7.6 36.7333C5.33333 33.8 3.48889 31 2.06667 28.3333C0.688889 25.6667 0 22.4444 0 18.6667C0 13.4667 1.8 9.06666 5.4 5.46666C9.04445 1.82222 13.4667 0 18.6667 0C23.8667 0 28.2667 1.82222 31.8667 5.46666C35.5111 9.06666 37.3333 13.4667 37.3333 18.6667C37.3333 22.7111 36.5556 26.0889 35 28.8C33.4889 31.4667 31.7333 34.1111 29.7333 36.7333C27.3333 39.9333 25.5111 42.6 24.2667 44.7333C23.0667 46.8222 22.0667 49.0444 21.2667 51.4C21.0445 52.0222 20.6889 52.5111 20.2 52.8667C19.7556 53.1778 19.2444 53.3333 18.6667 53.3333Z",
    fill: "#101111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.9f2b28b1280b03c19dc5ff0dc3a183c1.svg";
export { ForwardRef as ReactComponent };